// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"18":"2a006cc4","45":"3df9eedc","424":"6a444ac9","428":"98e62468","474":"8a109e3e","493":"6765b6d6","845":"8227cfc2"}[chunkId] + ".chunk.css";
};